module.exports = __webpack_public_path__ + "static/media/flow-monitor-info-alert.bc25115f.svg";